var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-12"},[_c('v-alert',{staticClass:"font-weight-medium",attrs:{"type":"warning","dense":""}},[_vm._v(" \"Please wait while we confirm your email\" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }